import React, { Component } from 'react'
import ReactQMap from 'react-qmap';
import { CommonlyHead } from '../routes/common/headnav';
let classMap, windowMap,infoWin;

export default class AddressMap extends Component {
  constructor(props){
    super(props);
    this.state={
      la:'',
      lo:'',

    }
   
  }


  _setMarker = () => {
    const marker = new windowMap.Marker({
      map: classMap,
      position: new windowMap.LatLng(this.props.match.params.la, this.props.match.params.lo),
      animation: windowMap.MarkerAnimation.DROP,
    });
    new windowMap.event.addListener(marker, 'click', function() {
      infoWin.open();
    });
    

  }

  _setInfoWindow = () => {
    const { name,address } =this.props.match.params;
    infoWin = new windowMap.InfoWindow({
      map: classMap,
    })
    infoWin.open();
    infoWin.setPosition(classMap.getCenter());
    infoWin.setContent(`<div style="text-align:center"><b style="font-size:.44rem,color:#333">${name}</b><p style="font-size:.38rem,margin:.2rem 0;color:#999">${address?address:" - "}</p></div>`);
    
  }
  _getMap = (map, wMap) => {
    classMap = map;
    windowMap = wMap;
    this._setInfoWindow();
    this._setMarker();   
  }
  render() {
    return (
      <div >
        <CommonlyHead barname={this.props.match.params.name} />
      <div style={{ overflowX: 'hidden', position: "relative", backgroundColor: "#fff" }}>                
        <ReactQMap
          // center={{ latitude: this.state.la, longitude: this.state.lo}}
           center={{ latitude: parseFloat(this.props.match.params.la)-0.0065, longitude: parseFloat(this.props.match.params.lo)-0.0060 }}
          getMap={(map, wMap) => this._getMap(map, wMap)}
          apiKey="QMABZ-DWGWU-72UVO-4MV44-CDJ75-ENBF3"
          style={{ height: document.documentElement.clientHeight-45 }}    // 高度和宽度默认占父元素的100%
        />
      </div>
      </div>
    )
  }
}
